/**
 * Retries `fn` only on network-level failures (fetch rejects before a response arrives,
 * e.g. offline/DNS/connection reset — always a TypeError on both browser and React Native
 * fetch implementations). HTTP error responses (4xx/5xx) are NOT retried here since the
 * server already received and processed the request.
 */
export async function withNetworkRetry<T>(
  fn: () => Promise<T>,
  retries = 2,
  baseDelayMs = 400,
): Promise<T> {
  for (let attempt = 0; ; attempt++) {
    try {
      return await fn();
    } catch (err) {
      const isNetworkError = err instanceof TypeError;
      if (!isNetworkError || attempt >= retries) throw err;
      await new Promise((resolve) => setTimeout(resolve, baseDelayMs * 2 ** attempt));
    }
  }
}
